import type { ComponentProps } from "react";

import { cn } from "./cn";

/** Underlined tabs (role=tablist / role=tab with aria-selected), as in the prototypes. */
export function TabList({ className, ...props }: ComponentProps<"div">) {
  return <div role="tablist" className={cn("flex flex-wrap gap-1 border-b border-border", className)} {...props} />;
}

export function Tab({ className, selected, ...props }: ComponentProps<"button"> & { selected: boolean }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={selected}
      className={cn(
        "-mb-px flex-1 cursor-pointer border-b-[3px] border-transparent bg-transparent px-3.5 py-2.5 font-medium",
        "aria-selected:border-primary aria-selected:font-bold aria-selected:text-primary",
        className,
      )}
      {...props}
    />
  );
}
